module.exports = __webpack_public_path__ + "img/apple-iphone-6s.5cfe6238.png";